import i18n, { persistLocale } from '../utils/i18n';
import * as ActionTypes from '../actions';

export default _store => next => action => {
  // Apply locale from auth response (login/refresh) and persist it so other
  // tabs and the next reload pick the same value up.
  if (action.type === ActionTypes.AUTH_RECEIVE || action.type === ActionTypes.AUTH_REFRESH_RECEIVE) {
    const locale = action.payload && action.payload.data && action.payload.data.locale;
    if (locale && locale !== i18n.language) {
      i18n.changeLanguage(locale);
      persistLocale(locale);
    }
  }

  return next(action);
};
